import { OAuth2AuthCodePKCE } from '@bity/oauth2-auth-code-pkce';

import { SSO_REDIRECT_URL } from './helper';
import { organisation } from './services/onPremAPI';

const TENANT_ID_COOKIE = 'sTenantId';

export const getPkceAuthClient = (response, redirectUrl) => {
  return new OAuth2AuthCodePKCE({
    authorizationUrl: `${response.jacksonUrl}/api/oauth/authorize`,
    tokenUrl: `${response.jacksonUrl}/api/oauth/token`,
    clientId: 'dummy',
    redirectUrl,
    scopes: [],
    onAccessTokenExpiry(refreshAccessToken) {
      console.log('Expired! Access token needs to be renewed.');
      alert('We will try to get a new access token via grant code or refresh token.');
      return refreshAccessToken();
    },
    onInvalidGrant(refreshAuthCodeOrRefreshToken) {
      console.log('Expired! Auth code or refresh token needs to be renewed.');
      alert('Redirecting to auth server to obtain a new auth grant code.');
      //return refreshAuthCodeOrRefreshToken();
    },
  });
};

export const readCookie = name => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const deleteCookie = name => {
  if (name) {
    // Set an expiration date in the past
    document.cookie = `${name}=;expires=expires=Thu, 01 Jan 1970 00:00:01 GMT; Max-Age=0; path=/;`;
  }
};

export const redirectToIdp = async redirectToLoginCallback => {
  const tenantName = readCookie(TENANT_ID_COOKIE);
  if (tenantName) {
    deleteCookie(TENANT_ID_COOKIE);
    const organisationDetails = await organisation();
    if (organisationDetails) {
      const pkceAuthClient = getPkceAuthClient(organisationDetails, SSO_REDIRECT_URL);
      if (pkceAuthClient) {
        return pkceAuthClient.fetchAuthorizationCode({
          tenant: tenantName,
          product: organisationDetails.product,
        });
      }
    }
  }
  redirectToLoginCallback && redirectToLoginCallback();
};
